module.exports = __webpack_public_path__ + "static/gallery-img-26-35aac20a9e3b8eb845cb4fe38bf9e6bf.jpg";